<div style="padding: 16px 24px;">
    @if (billingReport$ | async; as br) {
        <app-billing-report [billingReport]="br" [tableHeight]="400"></app-billing-report>
    }
</div>